import styles from "./WebinarReportTable.module.css";

const WebinarReportTable = ({ data }) => {
  return (
    <div className={styles.TableContainer}>
      <table className={styles.Table}>
        <thead>
          <tr>
            <th>Month</th>
            <th>Webinars</th>
            <th>Total registrations</th>
            <th>Avg. Registrations/Webinar</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={index}>
              <td>{row.month}</td>
              <td>{row.webinars}</td>
              <td>{row.registrations}</td>
              <td>{row.avgRegistrations}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default WebinarReportTable;
